import React from 'react';
import { cn } from '../../lib/utils';
import { PulseSeverity } from '../../types';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'compact' | 'stat' | 'announcement';
  severity?: PulseSeverity;
}

export const Card: React.FC<CardProps> = ({ 
  children, 
  variant = 'default', 
  severity,
  className,
  ...props
}) => {
  const variants = {
    default: 'bg-white border-4 border-black rounded-none shadow-[8px_8px_0px_#000000] p-6 dark:bg-black dark:border-white dark:shadow-[8px_8px_0px_#FFFFFF]',
    compact: 'bg-white border-2 border-black rounded-none shadow-[4px_4px_0px_#000000] p-3 dark:bg-black dark:border-white dark:shadow-[4px_4px_0px_#FFFFFF]',
    stat: 'bg-white border-4 border-black rounded-none shadow-[4px_4px_0px_#000000] p-6 dark:bg-black dark:border-white dark:shadow-[4px_4px_0px_#FFFFFF]', 
    announcement: 'bg-white border-4 border-black border-l-8 rounded-none shadow-[8px_8px_0px_#000000] p-6 dark:bg-black dark:border-white dark:shadow-[8px_8px_0px_#FFFFFF]',
  };

  // Section 12: Pulse Severity Colors (Left accent border + high contrast text)
  const severities = {
    CRITICAL: 'bg-white dark:bg-black !border-l-[#FF0000] text-black dark:text-white',
    HIGH: 'bg-white dark:bg-black !border-l-[#FFD600] text-black dark:text-white',
    MEDIUM: 'bg-white dark:bg-black !border-l-[#0044FF] text-black dark:text-white',
    LOW: 'bg-white dark:bg-black !border-l-gray-400 dark:!border-l-gray-600 text-black dark:text-white',
  };

  return (
    <div
      className={cn(
        variants[variant],
        variant === 'announcement' && severity ? severities[severity] : '',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
